import { authCall, endpoints } from '../api';
import { showToast } from './toast';

export const handleVerifyEmail = async (setLoading: (loading: boolean) => void,  closeBanner?: () => void) => {
  if (setLoading) setLoading(true);
  try {
    await authCall({
      url: endpoints.sendVerificationEmail,
      method: 'post',
    });

    showToast({
      title: 'Verification Email Sent',
      description: 'A verification email has been sent to your email.',
      status: 'success',
      id: 'verify-email-success',
    });

    if(closeBanner){
     closeBanner()
    }
  } catch (error) {
    showToast({
      title: 'Error Sending Verification Email',
      description: (error as Error).message,
      status: 'error',
      id: 'verify-email-error',
    });
  } finally {
    if (setLoading) setLoading(false);
  }
};
